module.exports = __webpack_public_path__ + "img/kefu.0b8f1a48.png";